import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const PhysicalTherapy = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my physical therapy business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps physical therapy businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for physical therapy businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most physical therapy businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my physical therapy business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like physical therapy. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Physical Therapy - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Physical Therapy CRM", url: "/industries/physical-therapy" }
  ];

  const industryData = {
    name: 'Physical Therapy',
    title: 'Fill Your Schedule & Improve Patient Compliance Rates',
    subtitle: 'Automate appointment reminders, track treatment progress, and keep patients engaged through full recovery',
    icon: '🏥',
    challenges: [
      'Patients skip follow-up appointments',
      'Poor compliance with home exercises',
      'High no-show rates',
      'Hard to demonstrate progress to insurance',
      'Difficult to manage multiple therapists'
    ],
    solutions: [
      'Automated appointment and exercise reminders',
      'Home exercise video delivery',
      'Progress tracking and documentation',
      'Insurance reporting automation',
      'Multi-therapist scheduling'
    ],
    features: [
      'Patient CRM with treatment plans',
      'Automated appointment reminders',
      'Exercise video library',
      'Progress tracking',
      'Insurance documentation',
      'Online booking',
      'Treatment plan management',
      'Review automation'
    ],
    results: [
      '60% improvement in compliance',
      '45% reduction in no-shows',
      '80% complete full treatment plans',
      '5.8K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Physical Therapy UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for physical therapy businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for physical therapy UK, physical therapy business software, physical therapy customer management, physical therapy lead generation UK"
        url="/industries/physical-therapy"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default PhysicalTherapy;